import {Component, OnInit} from '@angular/core';
import {WdrWetterbericht} from "../../../../../../model/vorhersagen/wdr-wetterbericht";
import {FirebaseService} from "../../../../../../service/firebase/firebase.service";
import {take} from "rxjs/operators";

@Component({
  selector: 'app-wdr',
  templateUrl: './wdr.component.html',
  styleUrls: ['../wetterbericht.component.css']
})
export class WdrComponent implements OnInit {

  wdrBericht: WdrWetterbericht;
  selectedIndex: number = 0;
  isLoading = true;

  constructor(private firebaseService: FirebaseService) {
  }

  ngOnInit(): void {
    this.loadBerichte();
  }

  private loadBerichte() {
    this.isLoading = true;
    this.firebaseService.getTerminalTexteWDR()
      .pipe(take(1))
      .subscribe(querySnapshot => {
        querySnapshot.docs.map(doc => {
          this.wdrBericht = doc.data();
          this.createListen();
        });
      }, error => {
        console.log(error);
      }).add(() => {
      this.isLoading = false;
    });
  }

  private createListen() {
    this.createNrwListe();
    this.createVideoTextListe();
    this.createRegionenListe();
    this.createNordWestListe();
    this.createDeutschlandListe();
  }

  private createNrwListe() {
    let aussichten = this.wdrBericht.nordrheinwestfalen.aussichten;
    this.wdrBericht.nordrheinwestfalen.aussichten.aussichtsListe = [aussichten.tag01, aussichten.tag02, aussichten.tag03, aussichten.tag04];
  }

  private createVideoTextListe() {
    let aussichten = this.wdrBericht.videotext.aussichten;
    this.wdrBericht.videotext.aussichten.aussichtsListe = [aussichten.tag01, aussichten.tag02];

  }

  private createRegionenListe() {
    this.wdrBericht.regionen.regionsListe = [
      this.wdrBericht.regionen.aachen,
      this.wdrBericht.regionen.bielefeld,
      this.wdrBericht.regionen.bonn,
      this.wdrBericht.regionen.dortmund,
      this.wdrBericht.regionen.duisburg,
      this.wdrBericht.regionen.essen,
      this.wdrBericht.regionen.köln,
      this.wdrBericht.regionen.münster,
      this.wdrBericht.regionen.siegen,
      this.wdrBericht.regionen.wuppertal
    ];

  }

  private createNordWestListe() {
    let aussichten = this.wdrBericht.deutschlandnordwest.aussichten;
    this.wdrBericht.deutschlandnordwest.aussichten.aussichtsListe = [aussichten.tag01, aussichten.tag02, aussichten.tag03, aussichten.tag04];
  }

  private createDeutschlandListe() {
    let aussichten = this.wdrBericht.deutschland.aussichten;
    this.wdrBericht.deutschland.aussichten.aussichtsListe = [aussichten.tag01, aussichten.tag02, aussichten.tag03, aussichten.tag04];
  }
}
